import type { TourCatalogEntry } from '@userhub/widget'
import type { TourDef } from './types'

/**
 * A tour as the userhub catalog describes it (userhub plan G2: userhub stores no catalog, so the
 * entries always match the build that runs the tours). `epicId` / `featureId` are ids of userhub's
 * Niobe taxonomy; `taxonomy.niobe.json` next to this file is a snapshot of it (userhub
 * `api/seed/taxonomy.niobe.json`) that catalog.test.ts checks every tour against.
 */
export function toCatalogEntry(def: TourDef): TourCatalogEntry {
  return {
    number: def.number,
    version: def.version,
    title: def.title,
    summary: def.summary,
    minutes: def.minutes,
    epicId: def.epicId,
    ...(def.featureId ? { featureId: def.featureId } : {}),
    publishedOn: def.publishedOn,
  }
}

/** The `count` most recently published tours, newest first (ties: the higher number first). */
export function recentTours<T extends Pick<TourDef, 'number' | 'publishedOn'>>(defs: readonly T[], count = 5): T[] {
  return [...defs]
    .sort((a, b) => b.publishedOn.localeCompare(a.publishedOn) || b.number - a.number)
    .slice(0, count)
}
